/**
 * Unicorn Fairy Circles - Theme JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // Sticky Header
  const header = document.querySelector('[data-header]');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 50);
    });
  }
  
  // Fade in on scroll
  const fadeElements = document.querySelectorAll('.fade-in-up');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.animationPlayState = 'running';
      }
    });
  }, { threshold: 0.1 });
  
  fadeElements.forEach(el => {
    el.style.animationPlayState = 'paused';
    observer.observe(el);
  });
  
});

// Refresh cart drawer content via sections API (global helper)
async function refreshCartDrawer() {
  try {
    const response = await fetch('/?sections=cart-drawer');
    if (!response.ok) {
      throw new Error('Failed to fetch cart drawer section');
    }
    
    const data = await response.json();
    
    // Get the cart-drawer section HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
    
    // Update the drawer content
    const cartDrawer = document.querySelector('[data-cart-drawer]');
    const newDrawer = doc.querySelector('[data-cart-drawer]');
    if (newDrawer && cartDrawer) {
      cartDrawer.innerHTML = newDrawer.innerHTML;
    }
    
    // Update header cart count
    const newCount = doc.querySelector('[data-cart-count]')?.textContent || '0';
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = newCount;
    });
    
    return true;
    
  } catch (err) {
    console.error('Failed to refresh cart drawer:', err);
    return false;
  }
}

// Open cart drawer helper
function openCartDrawer() {
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  if (cartDrawer) {
    cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  if (cartOverlay) {
    cartOverlay.classList.add('open');
  }
}

// Close cart drawer helper
function closeCartDrawer() {
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  if (cartDrawer) {
    cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (cartOverlay) {
    cartOverlay.classList.remove('open');
  }
}

/**
 * Product Card Image Slideshow
 * - Cycles through variant images every 30 seconds
 * - Each card starts on a random image and fires at a random offset,
 *   so they never all flip at the same moment
 * - If a size filter is active on the page (Shop by Size), locks to that
 *   size's image instead of cycling
 */
function initCardSlideshows() {
  const INTERVAL_MS = 30000;
  const FADE_MS     = 300;

  // Detect active size filter from Shopify native filter URL params
  // e.g. ?filter.v.option.size=3%C3%973+Pillar+(8+oz+wax)
  let activeSizeFilter = null;
  const urlParams = new URLSearchParams(window.location.search);
  for (const [key, value] of urlParams.entries()) {
    if (key.toLowerCase().includes('option.size') || key.toLowerCase().includes('option.candle')) {
      activeSizeFilter = value.toLowerCase().trim();
      break;
    }
  }

  const cards = document.querySelectorAll('.product-card[data-size-images]');

  cards.forEach(function(card) {
    const raw = card.getAttribute('data-size-images');
    if (!raw) return;

    // Parse "Size Name|||image_url~~~Size Name|||image_url~~~..."
    const entries = raw.split('~~~').map(function(entry) {
      const parts = entry.split('|||');
      return { size: (parts[0] || '').trim(), url: (parts[1] || '').trim() };
    }).filter(function(e) { return e.size && e.url; });

    if (entries.length === 0) return;

    const img = card.querySelector('.product-card__img');
    if (!img) return;

    // On a size-filtered page: lock to that size, no cycling
    if (activeSizeFilter) {
      const match = entries.find(function(e) {
        return e.size.toLowerCase().includes(activeSizeFilter) ||
               activeSizeFilter.includes(e.size.toLowerCase());
      });
      if (match) {
        img.src = match.url;
        img.alt = match.size;
      }
      return;
    }

    if (entries.length < 2) return;

    // Randomize starting image so all cards show different sizes at page load
    let idx = Math.floor(Math.random() * entries.length);
    img.src = entries[idx].url;
    img.alt = entries[idx].size;

    function swapNext() {
      idx = (idx + 1) % entries.length;
      img.style.opacity = '0';
      setTimeout(function() {
        img.src = entries[idx].url;
        img.alt = entries[idx].size;
        img.style.opacity = '1';
      }, FADE_MS);
    }

    // Stagger: each card waits a random 0–30s before its first swap,
    // then runs on the regular 30s interval — keeps them all out of phase
    const stagger = Math.floor(Math.random() * INTERVAL_MS);
    setTimeout(function() {
      swapNext();
      setInterval(swapNext, INTERVAL_MS);
    }, stagger);
  });
}

document.addEventListener('DOMContentLoaded', initCardSlideshows);
